<agpr-take-over-panel
    [id]="id"
    header="Social.post.viewer.title"
    [showFooter]="true"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [responsiveWidth]="true"
    [minPanelWidth]="minPanelWidth"
    [maxPanelWidth]="maxPanelWidth"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close($event)"
>
    <div class="agpr-postViewer-container">
        <!-- @HACK empty div is needed to center agpr-postViewer-player -->
        <div></div>
        <div
            class="agpr-postViewer-player"
            [ngClass]="{'agpr-postViewer-player-insta' : _mention?.mediaType.id === mediaTypes.INSTAGRAM || _mention?.mediaType.id === mediaTypes.FACEBOOK}"
        >
            <agpr-scroll-panel class="agpr-postViewer-player-scrollPanel">
                <agpr-social-post-display
                    [mention]="_mention"
                ></agpr-social-post-display>
            </agpr-scroll-panel>
        </div>
        <div class="agpr-postViewer-postDetails">
            <agpr-scroll-panel>
                <agpr-social-post-details
                    [mention]="_mention"
                ></agpr-social-post-details>
            </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="close"
            (click)="hideSlideOverlay = true;"
            [style]="buttonTypesEnum.secondary"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
